import type * as React from 'react';

export enum ResolutionStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  UNRESOLVED = 'unresolved',
}

export type SuggestionAction = 'accept' | 'reject';

export type CoachSuggestion = {
  /**
   * unique identifier for each suggestion
   */
  id: string;

  /**
   * The title of the suggestion
   */
  title: React.ReactNode;

  /**
   * The content of the suggestion
   */
  content: React.ReactNode;

  /**
   * Resolution status of this suggestion
   */
  status: ResolutionStatus;

  /**
   * Callback for SuggestionAction for this suggestion
   */
  onAction: (action: SuggestionAction) => void;

  /**
   * Pass this for custom cases where the visual title is not a string
   * e.g. the title is composed of multiple DOM elements
   */
  ariaLabel?: string;
};
